<template>
  <div class="calendar">
    <div class="calendar-header flex flex-between">
      <div>
        <!-- <span
          class="iconfont icon-zuoshuangjiantou1"
          @click="toLastYear"
        ></span> -->
        <span
          class="hmicon icon-mjiantou-copy pointer"
          style="display:inline-block;"
          @click="toLastMonth"
        ></span>
      </div>
      <div>{{ currentYear }}年{{ currentMonth }}月</div>
      <div>
        <span
          class="hmicon icon-icon-youjiantou pointer"
          @click="toNextMonth"
        ></span>
        <!-- <span
          class="iconfont icon-youshuangjiantou1"
          @click="toNextYear"
        ></span> -->
      </div>
    </div>
    <div class="calendar-body">
      <div class="weeks flex flex-between">
        <span class="week" v-for="(v, i) in weeks" :key="i">{{ v }}</span>
      </div>
      <div class="days flex flex-wrap">
        <div
          class="day pointer"
          @click="selectDay(v)"
          v-for="(v, i) in calendarList"
          :key="i"
          :class="{ 'not-current-month': v.isCurentMonth !== 0 }"
        >
          <span v-if="v.count" class="badge">
            {{ v.count }}
          </span>
          <span :class="{ currentDay: currentDate.date === v.date }">{{
            v.day
          }}</span>
          <span v-if="v.hasCheckedIn" class="iconfont icon-gou2"></span>
        </div>
      </div>
    </div>
    <!-- <div class="day-tip">
      {{ dayTip }}
    </div> -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    checkedInDays: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dayTip: "",
      currentDate: {
        date: ""
      },
      calendarList: [],
      isSelectYears: false,
      isSelectMonth: false,
      weeks: ["日", "一", "二", "三", "四", "五", "六"],
      currentDay: new Date().getDate(),
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      today: moment().format("YYYY/MM/DD")
    };
  },
  created() {
    this.currentDate.date = this.today;
    this.dayTip =
      moment().format("MM月DD日 周") + this.weeks[new Date().getDay()];
    this.$emit("switchDay", moment().format("YYYY/MM/DD"));
    this.getStartAndEndDay();
  },
  computed: {
    days() {
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      const lastMonth = this.getlastMonthDays(now);
      const currentMonth = this.getCurrentMonthDays(now);
      const nextMonth = this.getNextMonthDays({
        now,
        currentMonthLength: currentMonth.length,
        lastMonthLength: lastMonth.length
      });
      const displayedMonth = lastMonth.concat(currentMonth).concat(nextMonth);
      this.$emit("selectDay", {
        startTime: moment(now).format("YYYY/MM/DD")
      });
      this.calendarList = displayedMonth;
      return displayedMonth;
    }
  },
  watch: {
    days(val) {
      this.calendarList = val;
    },
    checkedInDays(val) {
      val.map(o => {
        this.calendarList.forEach(v => {
          if (v.date === o) {
            v.hasCheckedIn = true;
          }
        });
      });
      this.$forceUpdate();
    }
  },
  methods: {
    // 获取上一个月的开始结束时间
    getLastMonthLastDay(now) {
      const start =
        moment(now)
          .subtract(1, "month")
          .format("YYYY/MM") + "/01";
      const end = parseInt(
        moment(start)
          .subtract(-1, "month")
          .add(-1, "days")
          .format("D")
      );
      return end;
    },
    // 获取当前月的天数
    getCurrentMonthDays(now) {
      const currentMonth = [];
      // 本月第一天
      const start =
        moment(now)
          .add(0, "month")
          .format("YYYY/MM") + "/01";
      // 本月最后一天
      const end = parseInt(
        moment(start)
          .add(1, "month")
          .add(-1, "days")
          .format("D")
      );
      const datePrefix = moment(now).format("YYYY/MM");
      for (let i = 1; i < end + 1; i++) {
        const day = i < 10 ? "0" + i : i;
        currentMonth.push({
          day: i,
          isCurentMonth: 0, // 代表本月
          date: `${datePrefix}/${day}`,
          count: 0
        });
      }
      return currentMonth;
    },
    getlastMonthDays(now) {
      // 本月第一天
      const start =
        moment(now)
          .add(0, "month")
          .format("YYYY/MM") + "/01";
      // 本月第一天是周几
      const weekOfday = parseInt(moment(start).format("d"));

      const lastMonth = [];
      const lastMonthEnd = this.getLastMonthLastDay(now);
      let lastMonthStart = null;
      //
      if (weekOfday === 0) {
        lastMonthStart = lastMonthEnd - 6;
      } else {
        lastMonthStart = lastMonthEnd - (weekOfday - 1);
      }
      const datePrefix = moment(now)
        .subtract(1, "months")
        .format("YYYY/MM");
      for (let i = lastMonthStart; i < lastMonthEnd + 1; i++) {
        const day = i < 10 ? "0" + i : i;
        lastMonth.push({
          day: i,
          isCurentMonth: -1, // 代表上月
          date: `${datePrefix}/${day}`,
          count: 0
        });
      }
      return lastMonth;
    },
    getNextMonthDays({
      now,
      maxdays = 42,
      currentMonthLength,
      lastMonthLength
    }) {
      const nextMonth = [];
      // 获取日历当前月显示的下月最后一天
      const nextMonthEndDay = maxdays - currentMonthLength - lastMonthLength;
      const datePrefix = moment(now)
        .add(1, "months")
        .format("YYYY/MM");
      for (let i = 1; i < nextMonthEndDay + 1; i++) {
        const day = i < 10 ? "0" + i : i;
        nextMonth.push({
          day: i,
          isCurentMonth: 1, // 代表下个月
          date: `${datePrefix}/${day}`,
          count: 0
        });
      }
      return nextMonth;
    },
    selectDay(date) {
      const { day, isCurentMonth } = date;
      if (isCurentMonth === -1) {
        this.currentMonth--;
        this.formatDate();
      } else if (isCurentMonth === 1) {
        this.currentMonth++;
        this.formatDate();
      }
      this.currentDay = day;
      // this.currentDate = date;
      this.$emit("switchDay", moment(date.date).format("YYYY/MM/DD"));
      this.dayTip =
        moment(date.date).format("MM月DD日 周") +
        this.weeks[new Date(date.date).getDay()];
    },
    toLastYear() {
      this.currentYear--;
      this.currentDay = 1;
      this.formatDate();
    },
    toLastMonth() {
      this.currentMonth--;
      this.currentDay = 1;
      this.formatDate();
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      this.$emit("changeMonth", moment(now).format("YYYY/MM/DD"));
    },
    toNextMonth() {
      this.currentMonth++;
      this.currentDay = 1;
      this.formatDate();
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      this.$emit("changeMonth", moment(now).format("YYYY/MM/DD"));
    },
    goMonth(currentMonth) {
      this.currentMonth = currentMonth;
      this.currentDay = 1;
      this.formatDate();

      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      this.$emit("changeMonth", moment(now).format("YYYY/MM/DD"));
    },
    toNextYear() {
      this.currentYear++;
      this.currentDay = 1;
      this.formatDate();
    },
    formatDate() {
      if (this.currentMonth > 12) {
        this.currentYear++;
        this.currentMonth = 1;
      } else if (this.currentMonth < 1) {
        this.currentYear--;
        this.currentMonth = 12;
      }
    },
    getCalendarDays() {
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      const lastMonth = this.getlastMonthDays(now);
      const currentMonth = this.getCurrentMonthDays(now);
      const nextMonth = this.getNextMonthDays({
        now,
        currentMonthLength: currentMonth.length,
        lastMonthLength: lastMonth.length
      });
      const displayedMonth = lastMonth.concat(currentMonth).concat(nextMonth);
      this.$emit("selectDay", {
        currentDate: moment(now).format("YYYY/MM/DD")
      });
      /*eslint vue/no-side-effects-in-computed-properties: [0] */
      this.calendarList = displayedMonth;
      return displayedMonth;
    },
    getStartAndEndDay() {
      const now = `${this.currentYear}/${this.currentMonth}/${this.currentDay}`;
      const lastMonth = this.getlastMonthDays(now);
      const currentMonth = this.getCurrentMonthDays(now);
      const nextMonth = this.getNextMonthDays({
        now,
        currentMonthLength: currentMonth.length,
        lastMonthLength: lastMonth.length
      });
      const statrtDate = this.getlastMonthDays(now)[0].date;
      const endDate = nextMonth[nextMonth.length - 1].date;
      this.$emit("getStartAndEndDay", {
        statrtDate,
        endDate
      });
    }
  }
};
</script>
<style scoped lang="scss">
$dayWidth: 40px;
$calendarWidth: $dayWidth * 7;
.calendar {
  width: $calendarWidth;
  margin: 0 auto;
  padding: 24px;
  color: #fff;
  &-header {
    margin-bottom: 24px;
    user-select: none;
  }
  .weeks {
    padding: 24px 0;
  }
  .days {
    padding: 24px 0 0;
  }
  .week {
    width: $dayWidth;
    text-align: center;
  }
  .day {
    position: relative;
    width: $dayWidth;
    height: $dayWidth;
    line-height: $dayWidth;
    text-align: center;
    transition: all 0.2s linear;
    color: #fff;
    .iconfont {
      position: absolute;
      bottom: -40px;
      left: 50%;
      transform: translateX(-50%);
      color: #2fc348;
      font-size: 24px;
    }
    .currentDay {
      display: inline-block;
      background: #fff;
      border-radius: 50%;
      height: 34px;
      width: 34px;
      line-height: 34px;
      color: #005ceb;
    }
    .badge {
      position: absolute;
      right: 43px;
      top: 16px;
      background-color: #e98c00;
      border-radius: 10px;
      color: #fff;
      display: inline-block;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
      padding: 0 6px;
      text-align: center;
      white-space: nowrap;
      transform: translateY(-50%) translateX(100%);
    }
  }
  .not-current-month {
    color: #fff;
    opacity: 0.5;
  }
  .day-tip {
    width: 328px;
    height: 52px;
    line-height: 52px;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
    margin: 0 auto;
    color: #005ceb;
    text-align: center;
  }
}
</style>
